import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Search } from "lucide-react";

const STATUSES = ["all","Pending", "In Progress", "Approved", "Rejected"];

export default function AgentLeads() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [status, setStatus] = useState("all");

  useEffect(() => { api.get("/agents/leads").then(r => setItems(r.data || [])).catch(()=>{}); }, []);

  const filtered = items.filter(it =>
    (status === "all" || it.status === status) &&
    (q === "" || [it.full_name, it.email, it.mobile, it.loan_type].some(v => String(v || "").toLowerCase().includes(q.toLowerCase())))
  );

  return (
    <div>
      <div className="overline">Lead pipeline</div>
      <h1 className="font-display text-3xl font-extrabold mt-1">My leads</h1>

      <div className="mt-6 card-flat p-4">
        <div className="flex flex-col sm:flex-row sm:items-center gap-3">
          <div className="relative flex-1">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-ink-muted"/>
            <Input data-testid="agent-leads-search" value={q} onChange={e=>setQ(e.target.value)} placeholder="Search name / mobile / loan type" className="pl-9 rounded-full"/>
          </div>
          <Select value={status} onValueChange={setStatus}>
            <SelectTrigger className="sm:w-44 rounded-full" data-testid="agent-leads-filter"><SelectValue/></SelectTrigger>
            <SelectContent>{STATUSES.map(s => <SelectItem key={s} value={s}>{s === "all" ? "All statuses" : s}</SelectItem>)}</SelectContent>
          </Select>
        </div>

        <div className="mt-4 overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="text-left text-ink-muted border-b border-slate-200">
              <th className="py-2 pr-3">Date</th><th className="py-2 pr-3">Customer</th><th className="py-2 pr-3">Mobile</th><th className="py-2 pr-3">Loan</th><th className="py-2 pr-3">Amount</th><th className="py-2 pr-3">Status</th>
            </tr></thead>
            <tbody>
              {filtered.length === 0 && <tr><td colSpan={6} className="py-10 text-center text-ink-muted">No leads.</td></tr>}
              {filtered.map(l => (
                <tr key={l.id} className="border-b border-slate-100">
                  <td className="py-3 pr-3 whitespace-nowrap text-xs">{new Date(l.created_at).toLocaleString("en-IN", { dateStyle: "medium" })}</td>
                  <td className="py-3 pr-3 font-medium">{l.full_name}<div className="text-xs text-ink-muted">{l.email}</div></td>
                  <td className="py-3 pr-3 font-mono text-xs">{l.mobile}</td>
                  <td className="py-3 pr-3">{l.loan_type}</td>
                  <td className="py-3 pr-3 font-semibold">₹{Number(l.loan_amount || 0).toLocaleString("en-IN")}</td>
                  <td className="py-3 pr-3"><span className={`text-xs px-2 py-0.5 rounded-full font-medium ${l.status === "Approved" ? "bg-green-100 text-green-700" : l.status === "Rejected" ? "bg-red-100 text-red-700" : "bg-amber-100 text-amber-700"}`}>{l.status}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
